<!--===================================
=            BUTTONS GROUP            =
====================================-->

<template>
  <v-container>
    <v-row no-gutters>
      <base-header>
        <div slot="page-header">Buttons Groups</div>
      </base-header>
    </v-row>

    <v-row no-gutters>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">Rounded buttons</div>
          <div slot="card-body">
            <v-card flat class="py-12">
              <v-card-text>
                <v-row align="center" justify="center">
                  <v-col cols="12">
                    <p class="text-center">Rounded</p>
                  </v-col>
                  <v-btn-toggle v-model="toggle_exclusive" rounded>
                    <v-btn>
                      <v-icon>mdi-format-align-left</v-icon>
                    </v-btn>
                    <v-btn>
                      <v-icon>mdi-format-align-center</v-icon>
                    </v-btn>
                    <v-btn>
                      <v-icon>mdi-format-align-right</v-icon>
                    </v-btn>
                    <v-btn>
                      <v-icon>mdi-format-align-justify</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="6">
        <base-card class="pa-2">
          <div slot="card-header">
            Mandatory
          </div>
          <div slot="card-body">
            <v-card flat class="py-12">
              <v-card-text>
                <v-row align="center" justify="center">
                  <v-col cols="12">
                    <p class="text-center">Mandatory</p>
                  </v-col>
                  <v-btn-toggle v-model="toggle_exclusive" mandatory>
                    <v-btn>
                      <v-icon>mdi-format-align-left</v-icon>
                    </v-btn>
                    <v-btn>
                      <v-icon>mdi-format-align-center</v-icon>
                    </v-btn>
                    <v-btn>
                      <v-icon>mdi-format-align-right</v-icon>
                    </v-btn>
                    <v-btn>
                      <v-icon>mdi-format-align-justify</v-icon>
                    </v-btn>
                  </v-btn-toggle>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Multiple</div>
          <div slot="card-body">
            <v-card flat class="py-5">
              <v-card-text>
                <v-row align="center" justify="center">
                  <v-col cols="12">
                    <p class="text-center">Multiple</p>
                  </v-col>
                  <v-btn-toggle v-model="toggle_exclusive" multiple>
                    <v-btn>
                      <v-icon>mdi-format-align-left</v-icon>
                    </v-btn>
                    <v-btn>
                      <v-icon>mdi-format-align-center</v-icon>
                    </v-btn>
                    <v-btn>
                      <v-icon>mdi-format-align-right</v-icon>
                    </v-btn>
                    <v-btn>
                      <v-icon>mdi-format-align-justify</v-icon>
                    </v-btn>
                  </v-btn-toggle>

                  <v-col cols="12" class="text-center">
                    Model: {{ toggle_exclusive }}
                  </v-col>
                </v-row>
              </v-card-text>
            </v-card>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">In toolbar</div>
          <div slot="card-body">
            <v-toolbar dense>
              <v-overflow-btn
                :items="dropdown_font"
                label="Select font"
                hide-details
                class="pa-0"
              >
              </v-overflow-btn>
            </v-toolbar>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">In toolbar</div>
          <div slot="card-body">
            <v-toolbar dense>
              <template v-if="$vuetify.breakpoint.mdAndUp">
                <v-divider vertical></v-divider>

                <v-overflow-btn
                  :items="dropdown_edit"
                  editable
                  label="Select size"
                  hide-details
                  class="pa-0"
                  overflow
                ></v-overflow-btn>

                <v-divider vertical></v-divider>

                <v-spacer></v-spacer>

                <v-btn-toggle
                  v-model="toggle_multiple"
                  color="primary"
                  dense
                  group
                  multiple
                >
                  <v-btn :value="1" text>
                    <v-icon>mdi-format-bold</v-icon>
                  </v-btn>

                  <v-btn :value="2" text>
                    <v-icon>mdi-format-italic</v-icon>
                  </v-btn>

                  <v-btn :value="3" text>
                    <v-icon>mdi-format-underline</v-icon>
                  </v-btn>

                  <v-btn :value="4" text>
                    <v-icon>mdi-format-color-fill</v-icon>
                  </v-btn>
                </v-btn-toggle>

                <div class="mx-4"></div>

                <v-btn-toggle
                  v-model="toggle_exclusive"
                  color="primary"
                  dense
                  group
                >
                  <v-btn :value="1" text>
                    <v-icon>mdi-format-align-left</v-icon>
                  </v-btn>

                  <v-btn :value="2" text>
                    <v-icon>mdi-format-align-center</v-icon>
                  </v-btn>

                  <v-btn :value="3" text>
                    <v-icon>mdi-format-align-right</v-icon>
                  </v-btn>

                  <v-btn :value="4" text>
                    <v-icon>mdi-format-align-justify</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </template>
            </v-toolbar>
          </div>
        </base-card>
      </v-col>
      <v-col cols="12" sm="12" md="12">
        <base-card class="pa-2">
          <div slot="card-header">Selected action</div>
          <div slot="card-body">
            <v-card max-width="400" class="mx-auto">
              <v-textarea
                v-model="value"
                auto-grow
                full-width
                rows="2"
              ></v-textarea>

              <v-row class="px-2 pb-2 ma-0" justify="space-between">
                <v-btn-toggle v-model="formatting" multiple>
                  <v-btn color="white">
                    <v-icon>mdi-format-italic</v-icon>
                  </v-btn>

                  <v-btn color="white">
                    <v-icon>mdi-format-bold</v-icon>
                  </v-btn>

                  <v-btn color="white">
                    <v-icon>mdi-format-underline</v-icon>
                  </v-btn>

                  <v-btn color="white">
                    <v-row align="center" class="flex-column" justify="center">
                      <v-icon class="cols 12">mdi-format-color-text</v-icon>

                      <v-sheet
                        tile
                        style="margin-top: -4px;"
                        height="4"
                        width="26"
                        color="purple"
                      ></v-sheet>
                    </v-row>
                  </v-btn>
                </v-btn-toggle>

                <v-btn-toggle v-model="alignment">
                  <v-btn color="white">
                    <v-icon>mdi-format-align-center</v-icon>
                  </v-btn>

                  <v-btn color="white">
                    <v-icon>mdi-format-align-left</v-icon>
                  </v-btn>

                  <v-btn color="white">
                    <v-icon>mdi-format-align-right</v-icon>
                  </v-btn>
                </v-btn-toggle>
              </v-row>

              <v-sheet class="pa-4 text-center" color="grey lighten-3" tile>
                <v-row class="mb-2" dense>
                  <v-col
                    v-for="n in numbers"
                    :key="n"
                    class="caption grey--text text--darken-1"
                    v-text="n"
                  >
                  </v-col>
                </v-row>

                <v-row dense>
                  <v-col
                    v-for="l in letters"
                    :key="l"
                    class="title grey--text font-weight-regular text--darken-2"
                    v-text="l"
                  ></v-col>
                </v-row>
              </v-sheet>
            </v-card>
          </div>
        </base-card>
      </v-col>
    </v-row>
  </v-container>
</template>
<script>
import BaseCard from "../../layout/Base/BaseCard.vue";
import BaseHeader from "../../layout/Base/BaseHeader.vue";
export default {
  components: {
    BaseCard,
    BaseHeader
  },
  data() {
    return {
      toggle_exclusive: undefined,
      dropdown_font: [
        {
          text: "Arial"
        },
        {
          text: "Calibri"
        },
        {
          text: "Courier"
        },
        {
          text: "Verdana"
        }
      ],
      dropdown_edit: [
        {
          text: "100%"
        },
        {
          text: "75%"
        },
        {
          text: "50%"
        },
        {
          text: "25%"
        },
        {
          text: "0%"
        }
      ],

      toggle_multiple: [1, 2, 3],
      alignment: 1,
      formatting: [],
      numbers: [1, 2, 3, 4, 5, 6, 7, 8, 9, 0],
      letters: "qwertyuiop".split(""),
      value:
        "Toggle button requirements.\r\rHave at least three toggle buttons in a group\rLabel buttons with text, an icon, or"
    };
  }
};
</script>

<!--====  End of BUTTONS GROUP  ====-->
